import React from "react";
import { Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

function NotFound() {
  return (
    <section className="section section--flush" aria-labelledby="notfound-heading">
      <div className="container container--narrow">
        <p className="section__eyebrow">404</p>
        <h1 id="notfound-heading" className="section__title">
          This page does not exist
        </h1>
        <p className="section__subtitle">
          The link may be outdated or mistyped. Everything lives on the home
          page.
        </p>
        <p className="stack-top">
          <Link className="btn btn--primary" to="/">
            <FiArrowLeft aria-hidden="true" />
            Back to home
          </Link>
        </p>
      </div>
    </section>
  );
}

export default NotFound;
